import { AdminApi } from 'stylemix-vue-admin'

export default class AirportRatesApi extends AdminApi {
  constructor(vehicleId, parameters) {
    super(`vehicles/${vehicleId}/airport-rates`, parameters)
  }
}
